import { Injectable } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { IProductCommandContext } from '@shared/models/command';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class BuyMetalCommand extends BaseProductCommand {
  readonly type = 'buy';
  readonly title = 'Купить';
  readonly icon = 'replenish';
  readonly productType = ProductTypes.METAL_ACCOUNT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 2; // Второй в actions для metallAccount

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push('/payments/transfer/self', {
      queryParams: {
        corrAccId: context.data.id,
        operationType: 'buyMetal'
      }
    });
  }
}

